// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__28gX-","additionalInfo":"AgreementModal_additionalInfo__DAWoJ"};